import { render, staticRenderFns } from "./IconLogo02.vue?vue&type=template&id=67cf26e2"
import script from "./IconLogo02.vue?vue&type=script&lang=ts"
export * from "./IconLogo02.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports